import React, { useRef } from "react";
import Lottie from "lottie-react";
import logo1 from "./logoToCreate01.json";
import logo2 from "./logoToCreate02.json";
 // Ajoute autant de fichiers que nécessaire

const animations = [logo1,logo2]; // Liste des fichiers JSON

const LogoAnimated = () => {
    const lottieRef = useRef();

    // Sélectionner un fichier aléatoire
    const randomAnimation = animations[Math.floor(Math.random() * animations.length)];

    return (
        <div>
            <Lottie
                lottieRef={lottieRef}
                animationData={randomAnimation}
                loop={false}
            />
        </div>
    );
};

export default LogoAnimated;
